import React from "react";
import { withRouter } from "react-router-dom";
import FormTabs from "../genericModifyPage/FormTabs";
import ParkingLotDetailsForm from "./ParkingLotDetailsForm";
import ParkingLotAllowedPaymentsForm from "./ParkingLotAllowedPaymentsForm";
import ParkingLotFinalStepForm from "./ParkingLotFinalStepForm";
import ParkingLotReservationSettingsForm from "./ParkingLotReservationSettingsForm";

function ParkingLotForm(props) {
  const [item, onChanged, onSave, onCancel] = [
    props.item,
    props.onChanged,
    props.onSave,
    props.onCancel,
  ];

  return (
    <FormTabs
      item={item}
      onChanged={onChanged}
      onSave={onSave}
      onCancel={onCancel}
      history={props.history}
      pageProps={props.pageProps}
      tabs={[
        {
          title: "Details",
          body: <ParkingLotDetailsForm />,
        },
        {
          title: "Allowed payments",
          body: <ParkingLotAllowedPaymentsForm />,
        },
        {
          title: "Reservation settings",
          body: <ParkingLotReservationSettingsForm />,
        },
        {
          title: "Final step",
          body: <ParkingLotFinalStepForm />,
        },
      ]}
    />
  );
}

export default withRouter(ParkingLotForm);
